import { CookbookMealListConnectorApollo } from '@front-activerse/common-components';
import CookbookFilterContainer from './CookbookFilterContainer';

const CookbookFilterPage = () => {
  return (
    <CookbookMealListConnectorApollo>
      {(cookbookMealListData) => <CookbookFilterContainer {...cookbookMealListData} />}
    </CookbookMealListConnectorApollo>
  );
};

export default CookbookFilterPage;
